import React from "react";

export interface ScreenWarningProps {
	warning: string;
}

export const ScreenWarning: React.FC<ScreenWarningProps> = ({warning}) => {
	if (warning === "rotate") {
		return (
			<div>
				There's too much in Beast Academy to fit in a screen this width.
				<br />
				Please rotate your device.
			</div>
		);
	} else {
		return (
			<div>
				Uh oh! There's too much in Beast Academy Online to fit in a screen this
				size!
				<br />
				Beast Academy Online works on tablets, laptops, and desktop computers.
			</div>
		);
	}
};
